import * as R from 'ramda';
import {of} from 'rxjs';

import ajax from 'iss/utils/ajax';

export const serviceTypesByCategory = ajax.cache("/service/by-category", 10 * ajax.MINUTES);
export const serviceTypes = ajax.cache("/service", 10 * ajax.MINUTES);
export const siteTypes = ajax.cache("/site-type", 10 * ajax.MINUTES);
export const siteSizes = ['UNDER_500','FROM_500_TO_1200','OVER_1200'];
export const partyActivationTypes = {
  siteCoordinator: 'SITE_COORDINATOR',
  informant: 'INFORMANT'
 };

export const activatedSitesByForm = R.memoizeWith(R.identity, function activatedSitesByForm(id) {
  if (!id) return of([]);
  return ajax.cache(`/form/${id}/activated-sites`, 3 * ajax.MINUTES, {showLoadingScreen: false});
});

export const profitCentersByContractExternalId = R.memoizeWith(R.identity, function profitCentersByContract(id) {
  if (!id) return of([]);
  return ajax.cache(`/contract/external/${id}/profit-centers`, 3 * ajax.MINUTES, {showLoadingScreen: false});
});

export function searchContracts(searchString, page, pageSize) {
  const searchParam = searchString.match(commaSeparatedLongNumbers) ?
    "externalIds="+sanitizeNumberList(searchString) :
    "searchTerm="+encodeURIComponent(searchString);
  return ajax.getJson(
    `/contract/search?${searchParam}&scope=QUALITY_MONITORING&resultFormat=full&page=${page}&size=${pageSize}`,
    {showLoadingScreen: false}
  );
}

const commaSeparatedLongNumbers = /^[\s,.]*([0-9]{4,}[\s.,]+)+[0-9]+[\s,.]*$/;

function sanitizeNumberList(numbers) {
  return numbers
    .split(/[\s,.]+/)
    .filter(s => s != '')
    .join(",");
}



// WEBPACK FOOTER //
// ./modules/issFrontend/service/ActivationDataService.js